export const boot = () => {
  window.Intercom("showNewMessage");
};
